import React, { useContext } from "react";

import { Grid } from "@material-ui/core";
import {
  UserSubscriptions,
  Tabs,
  SectionTitle,
  PendingComponent,
} from "../../_common";
import { MdTimelapse } from "react-icons/md";

import { Context as AuthContext } from "../../../context/AuthContext";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import useStyles from "./styles";

const Subscriptions = () => {
  const { sRoot } = useStyles();
  const {
    state: { user },
  } = useContext(AuthContext);
  return (
    <Grid container direction="column" className={sRoot} wrap="nowrap">
      <SectionTitle title="Suscripciones" />
      <Tabs
        tabs={[
          {
            title: "Pendientes",
            icon: <MdTimelapse fontSize="inherit" />,
            component: (
              <UserSubscriptions
                data={user.campaign_subscriptions}
                title="Pendientes"
              />
            ),
            renders: true,
          },
          {
            title: "Aprobadas",
            icon: <IoMdCheckmarkCircleOutline />,
            component: (
              <PendingComponent message="Este componente está en desarrollo." />
            ),
            renders: true,
          },
        ]}
      />
    </Grid>
  );
};

export default Subscriptions;
